<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    :show-close="false"
    center
    custom-class="el-dialog-import-sim"
    width="35%"
    top="30vh"
    :append-to-body="appendToBody"
    class="import-dialog"
  >
    <dialog-header
      slot="title"
      :title="$t('public.importDialog.title')"
      @close="closeDialog"
    />
    <el-row :gutter="10" type="flex" justify="center">
      <el-col :span="16">
        <el-form>
          <el-form-item label-position="'right'" label-width="50px" :label="$t('public.importDialog.file')+'：'">
            <el-input v-model="leadingInPath" disabled />
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4" type="flex" align="end">
        <el-upload
          ref="upload"
          :headers="{Authorization: token,language: lang}"
          :auto-upload="false"
          :show-file-list="false"
          :file-list="fileList"
          :multiple="true"
          :before-upload="beforeupload"
          :on-change="fileChange"
          :on-success="fileSuccess"
          :on-error="fileError"
          :action="action"
          :data="data"
          class="el-upload-block"
        >
          <el-button type="primary">
            {{ $t('public.importDialog.browse') }}
          </el-button>
        </el-upload>
      </el-col>
    </el-row>
    <div class="import-remark">
      {{ $t('public.importDialog.note') }}
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="dialog-cancel" type="primary">
        <a :href="templateUrl">{{ $t('public.importDialog.downloadTemplate') }} </a>
      </el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('public.define') }} </el-button>
    </span>
    <slot />
  </el-dialog>
</template>

<script>
import { getUserLanguage } from '@/utils/auth'
// 验证是否为excel
import readExcel from '@/utils/readExcel'
// import resultDialog from './resultDialog'
export default {
  name: 'ImportDialog',
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: ''
    },
    templateUrl: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      lang: getUserLanguage(),
      leadingInPath: '',
      fileList: [],
      successList: [],
      failedList: [],
      uploadloading: null,
      uid: ''
      // resultVisible: false,
      // data: {}
    }
  },
  computed: {
    token() {
      return this.$store.getters.token
    }
  },
  // components: { resultDialog },
  watch: {
    visibles(e1) {
      if (e1) {
        this.leadingInPath = ''
        this.uid = ''
      }
    }
  },
  methods: {
    // 重置数据
    restStatus() {
      this.fileList = []
      this.leadingInPath = ''
      this.uploadloading.close()
    },
    // 上传之前得验证
    beforeupload(file) {
      this.uid = file.uid
    },
    // 文件状态改变时触发
    fileChange(file, fileList) {
      // if (file.size / 1024 > 300) {
      //   this.$message({
      //     message: "上传文件大小不应超过300KB，请重新上传",
      //     type: "error"
      //   });
      //   return;
      // }
      // 获取最新的文件
      this.fileList = fileList.slice(-1)
      readExcel({ 0: file.raw }).then(() => {
        this.leadingInPath = file.name
      })
        .catch(err => {
          console.log(err)
        })
    },
    // 导入车辆上传成功钩子
    fileSuccess(response) {
      if (response.code === 0 && response.data) {
        this.$notify({
          title: this.$t('public.importDialog.success'),
          message: this.$t('public.importDialog.uploadSuccess'),
          type: 'success',
          duration: 3000
        })
        // this.resultVisible = true
        // this.data = response.data
        this.$emit('upload-success', response.data)
      } else {
        this.$message.error({
          message: response.message,
          duration: 2 * 1000
        })
      }
      this.restStatus()
    },
    // 导入车辆上传失败钩子
    // eslint-disable-next-line no-unused-vars
    fileError(response, file, fileListt) {
      this.restStatus()
    },
    // 关闭
    closeDialog() {
      this.$emit('update:visibles', false)
    },
    // 取消
    handleCancel() {
      this.closeDialog()
    },
    // 提交
    handleSubmit() {
      if (this.fileList.length === 0) {
        this.$message.error({
          message: this.$t('public.importDialog.selectFile'),
          duration: 2 * 1000
        })
        return
      }
      if (this.uid === this.fileList[0].uid) {
        this.$message.error({
          message: this.$t('public.importDialog.restFile'),
          duration: 2 * 1000
        })
        return false
      }
      this.$refs.upload.submit()
      this.uploadloading = this.$loading({
        target: document.querySelector('.el-dialog-import-sim'),
        text: this.$t('public.uploading') + '...',
        background: 'rgba(1, 1, 1, 0.3)',
        customClass: 'svg-otherColor'
      })
    }
  }
}
</script>

<style lang="scss">
.import-remark{
  color: red;
  text-align: center;
  padding-bottom:20px
}
.import-dialog .el-dialog, .import-dialog .el-dialog__body{
  background: #fff!important;
}
</style>
